<template>
  <div class="shu">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png" style="margin-right:10px" alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>工作流</el-breadcrumb-item>
          <el-breadcrumb-item>竖</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div class="refresh">
        <img :class="isRefresh ?'imgmove':''" width="16px" height="16px" src="@/assets/house/refresh.png" alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>竖</h4>
      </div>

      <div class="kabj">
        <div v-for="e in 6" :key="e" class="ka">
          <img width="103" height="103" src="@/assets/container/icon.png" alt="">
          <div class="text">
            <p>用户认证审核</p>
            <p style="margin-top: 15px;">您可以通过此工作流程对所有申请认证的用户进行审核或对已审核的信息进行导出。</p>
            <div class="link">
              <div>未审核</div>
              <div>已通过</div>
              <div>已拒绝</div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getDate,formatConversion } from "@/plugins/getdate";

export default {

  data() {
    return {
      isRefresh:false
    };
  },
  methods: {
    
  },
  created() {

  },
  beforeDestroy(){ 
     
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./shu.scss";

</style>
